// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/capability/v1/capability_links.proto (package mono.capability.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { CapabilityLinkTarget, CapabilityProofView, CapabilityRequirementLinkRecord } from "../../datagateway/v1/capability_links_pb";
/**
 * @generated from message mono.capability.v1.LinkCapabilityToRequirementRequest
 */ export class LinkCapabilityToRequirementRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkCapabilityToRequirementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkCapabilityToRequirementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkCapabilityToRequirementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkCapabilityToRequirementRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * RFI_QUESTION | PROPOSAL_REQUIREMENT
   *
   * @generated from field: string target_kind = 2;
   */ _define_property(this, "targetKind", ""), /**
   * @generated from field: string rfi_question_id = 3;
   */ _define_property(this, "rfiQuestionId", ""), /**
   * @generated from field: string proposal_project_id = 4;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string proposal_requirement_id = 5;
   */ _define_property(this, "proposalRequirementId", ""), /**
   * at most 500 Unicode characters
   *
   * @generated from field: string note = 6;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkCapabilityToRequirementRequest, "runtime", proto3);
_define_property(LinkCapabilityToRequirementRequest, "typeName", "mono.capability.v1.LinkCapabilityToRequirementRequest");
_define_property(LinkCapabilityToRequirementRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "target_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rfi_question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "proposal_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.UnlinkCapabilityRequirementRequest
 */ export class UnlinkCapabilityRequirementRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkCapabilityRequirementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkCapabilityRequirementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkCapabilityRequirementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkCapabilityRequirementRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string link_id = 1;
   */ _define_property(this, "linkId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkCapabilityRequirementRequest, "runtime", proto3);
_define_property(UnlinkCapabilityRequirementRequest, "typeName", "mono.capability.v1.UnlinkCapabilityRequirementRequest");
_define_property(UnlinkCapabilityRequirementRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Exactly one selector: capability_id, rfi_question_id, or the proposal pair.
 * History includes unlink provenance; invisible targets are omitted.
 *
 * @generated from message mono.capability.v1.ListCapabilityRequirementLinksRequest
 */ export class ListCapabilityRequirementLinksRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityRequirementLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityRequirementLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityRequirementLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityRequirementLinksRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string rfi_question_id = 2;
   */ _define_property(this, "rfiQuestionId", ""), /**
   * @generated from field: string proposal_project_id = 3;
   */ _define_property(this, "proposalProjectId", ""), /**
   * @generated from field: string proposal_requirement_id = 4;
   */ _define_property(this, "proposalRequirementId", ""), /**
   * @generated from field: bool include_history = 5;
   */ _define_property(this, "includeHistory", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityRequirementLinksRequest, "runtime", proto3);
_define_property(ListCapabilityRequirementLinksRequest, "typeName", "mono.capability.v1.ListCapabilityRequirementLinksRequest");
_define_property(ListCapabilityRequirementLinksRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proposal_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "proposal_requirement_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "include_history",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.SearchCapabilityLinkTargetsRequest
 */ export class SearchCapabilityLinkTargetsRequest extends Message {
    static fromBinary(bytes, options) {
        return new SearchCapabilityLinkTargetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchCapabilityLinkTargetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchCapabilityLinkTargetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchCapabilityLinkTargetsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string query = 1;
   */ _define_property(this, "query", ""), /**
   * default 20, maximum 50
   *
   * @generated from field: int32 limit = 2;
   */ _define_property(this, "limit", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchCapabilityLinkTargetsRequest, "runtime", proto3);
_define_property(SearchCapabilityLinkTargetsRequest, "typeName", "mono.capability.v1.SearchCapabilityLinkTargetsRequest");
_define_property(SearchCapabilityLinkTargetsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "query",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "limit",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.LinkCapabilityToRequirementResponse
 */ export class LinkCapabilityToRequirementResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkCapabilityToRequirementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkCapabilityToRequirementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkCapabilityToRequirementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkCapabilityToRequirementResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CapabilityRequirementLinkRecord link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkCapabilityToRequirementResponse, "runtime", proto3);
_define_property(LinkCapabilityToRequirementResponse, "typeName", "mono.capability.v1.LinkCapabilityToRequirementResponse");
_define_property(LinkCapabilityToRequirementResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: CapabilityRequirementLinkRecord
        }
    ]));
/**
 * @generated from message mono.capability.v1.UnlinkCapabilityRequirementResponse
 */ export class UnlinkCapabilityRequirementResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnlinkCapabilityRequirementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnlinkCapabilityRequirementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnlinkCapabilityRequirementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnlinkCapabilityRequirementResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnlinkCapabilityRequirementResponse, "runtime", proto3);
_define_property(UnlinkCapabilityRequirementResponse, "typeName", "mono.capability.v1.UnlinkCapabilityRequirementResponse");
_define_property(UnlinkCapabilityRequirementResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.capability.v1.ListCapabilityRequirementLinksResponse
 */ export class ListCapabilityRequirementLinksResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityRequirementLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityRequirementLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityRequirementLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityRequirementLinksResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapabilityRequirementLinkRecord links = 1;
   */ _define_property(this, "links", []), /**
   * @generated from field: bool can_link = 2;
   */ _define_property(this, "canLink", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityRequirementLinksResponse, "runtime", proto3);
_define_property(ListCapabilityRequirementLinksResponse, "typeName", "mono.capability.v1.ListCapabilityRequirementLinksResponse");
_define_property(ListCapabilityRequirementLinksResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "links",
            kind: "message",
            T: CapabilityRequirementLinkRecord,
            repeated: true
        },
        {
            no: 2,
            name: "can_link",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.SearchCapabilityLinkTargetsResponse
 */ export class SearchCapabilityLinkTargetsResponse extends Message {
    static fromBinary(bytes, options) {
        return new SearchCapabilityLinkTargetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchCapabilityLinkTargetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchCapabilityLinkTargetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchCapabilityLinkTargetsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapabilityLinkTarget targets = 1;
   */ _define_property(this, "targets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SearchCapabilityLinkTargetsResponse, "runtime", proto3);
_define_property(SearchCapabilityLinkTargetsResponse, "typeName", "mono.capability.v1.SearchCapabilityLinkTargetsResponse");
_define_property(SearchCapabilityLinkTargetsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "targets",
            kind: "message",
            T: CapabilityLinkTarget,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.capability.v1.AddCapabilityProofRequest
 */ export class AddCapabilityProofRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddCapabilityProofRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCapabilityProofRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCapabilityProofRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCapabilityProofRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string proof_kind = 3;
   */ _define_property(this, "proofKind", ""), /**
   * @generated from field: string program_id = 4;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string registry_contract_id = 5;
   */ _define_property(this, "registryContractId", ""), /**
   * @generated from field: string note = 6;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCapabilityProofRequest, "runtime", proto3);
_define_property(AddCapabilityProofRequest, "typeName", "mono.capability.v1.AddCapabilityProofRequest");
_define_property(AddCapabilityProofRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "proof_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "registry_contract_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.AddCapabilityProofResponse
 */ export class AddCapabilityProofResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddCapabilityProofResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddCapabilityProofResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddCapabilityProofResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddCapabilityProofResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CapabilityProofView proof = 1;
   */ _define_property(this, "proof", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddCapabilityProofResponse, "runtime", proto3);
_define_property(AddCapabilityProofResponse, "typeName", "mono.capability.v1.AddCapabilityProofResponse");
_define_property(AddCapabilityProofResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proof",
            kind: "message",
            T: CapabilityProofView
        }
    ]));
/**
 * @generated from message mono.capability.v1.RemoveCapabilityProofRequest
 */ export class RemoveCapabilityProofRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveCapabilityProofRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveCapabilityProofRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveCapabilityProofRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveCapabilityProofRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveCapabilityProofRequest, "runtime", proto3);
_define_property(RemoveCapabilityProofRequest, "typeName", "mono.capability.v1.RemoveCapabilityProofRequest");
_define_property(RemoveCapabilityProofRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.RemoveCapabilityProofResponse
 */ export class RemoveCapabilityProofResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveCapabilityProofResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveCapabilityProofResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveCapabilityProofResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveCapabilityProofResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveCapabilityProofResponse, "runtime", proto3);
_define_property(RemoveCapabilityProofResponse, "typeName", "mono.capability.v1.RemoveCapabilityProofResponse");
_define_property(RemoveCapabilityProofResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * History retains unlink provenance, subject to current artifact and program visibility.
 *
 * @generated from message mono.capability.v1.ListCapabilityProofsRequest
 */ export class ListCapabilityProofsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityProofsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityProofsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityProofsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityProofsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capability_id = 1;
   */ _define_property(this, "capabilityId", ""), /**
   * @generated from field: bool include_history = 2;
   */ _define_property(this, "includeHistory", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityProofsRequest, "runtime", proto3);
_define_property(ListCapabilityProofsRequest, "typeName", "mono.capability.v1.ListCapabilityProofsRequest");
_define_property(ListCapabilityProofsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capability_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "include_history",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.capability.v1.ListCapabilityProofsResponse
 */ export class ListCapabilityProofsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListCapabilityProofsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListCapabilityProofsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListCapabilityProofsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListCapabilityProofsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.CapabilityProofView proofs = 1;
   */ _define_property(this, "proofs", []), /**
   * @generated from field: string gap = 2;
   */ _define_property(this, "gap", ""), /**
   * @generated from field: bool can_link = 3;
   */ _define_property(this, "canLink", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListCapabilityProofsResponse, "runtime", proto3);
_define_property(ListCapabilityProofsResponse, "typeName", "mono.capability.v1.ListCapabilityProofsResponse");
_define_property(ListCapabilityProofsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proofs",
            kind: "message",
            T: CapabilityProofView,
            repeated: true
        },
        {
            no: 2,
            name: "gap",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "can_link",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
